import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { OverlayContext } from '../../providers/OverlayContextProvider';
import { generateUniqueId } from '../../utils/generateUniqueId';
import { useStateInRef } from '../../utils/useStateInRef';
function PortalHost(param) {
    let { element } = param;
    const attachElement = (node)=>{
        if (node != null && element.parentElement !== node) {
            node.appendChild(element);
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display: 'contents'
        },
        ref: attachElement
    });
}
export function useHostInBottomSheet(options) {
    const { enabled } = options;
    const overlay = useContext(OverlayContext);
    const pageId = useMemo(()=>generateUniqueId('surface-sheet-page'), []);
    const portalTarget = useMemo(()=>{
        const element = document.createElement('div');
        element.style.display = 'contents';
        return element;
    }, []);
    const joinedRef = useRef(false);
    const getArgs = useStateInRef(_object_spread_props(_object_spread({}, options), {
        overlay
    }));
    useEffect(()=>{
        if (!enabled) return undefined;
        const args = getArgs();
        const sheetAlreadyOpen = args.overlay.getHasOpenBottomSheet();
        const addPage = !sheetAlreadyOpen ? args.overlay.showBottomSheet : args.overlay.pushBottomSheetPage;
        joinedRef.current = true;
        addPage({
            id: pageId,
            content: /*#__PURE__*/ _jsx(PortalHost, {
                element: portalTarget
            }),
            onRemoved: ()=>{
                if (!joinedRef.current) return;
                joinedRef.current = false;
                getArgs().onRemovedFromStack();
            }
        });
        return ()=>{
            if (!joinedRef.current) return;
            joinedRef.current = false;
            if (getArgs().hideSheetOnLeave) {
                getArgs().overlay.hideBottomSheet();
            } else {
                getArgs().overlay.removeBottomSheetPage(pageId);
            }
        };
    }, [
        enabled,
        portalTarget,
        pageId
    ]);
    return enabled ? {
        portalTarget,
        pageId
    } : null;
}
